import { render, staticRenderFns } from "./QuizSection.vue?vue&type=template&id=4f129e4b&"
import script from "./QuizSection.vue?vue&type=script&lang=js&"
export * from "./QuizSection.vue?vue&type=script&lang=js&"
import style0 from "./QuizSection.vue?vue&type=style&index=0&id=4f129e4b&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports